import { environment } from '@lla-platform/core/core-util'

export const REPORTS_API_URL = {
  callsReport: `${environment.apiUrl}/reports/calls`,
  salesReport: `${environment.apiUrl}/reports/sales`,
  compareReport: `${environment.apiUrl}/comparison/objectives`,
  monthlyObjectiveRankings: `${environment.apiUrl}/comparison/monthly-moving-average`,
  exportMonthlyObjectiveRankings: `${environment.apiUrl}/comparison/monthly-moving-average/export`,
  weeklyObjectiveRankings: `${environment.apiUrl}/comparison/weekly-moving-average`,
  exportWeeklyObjectiveRankings: `${environment.apiUrl}/comparison/weekly-moving-average/export`,
  monthlyArMovingAverage: `${environment.apiUrl}/comparison/client-monthly-moving-average`,
  exportMonthlyArMovingAverage: `${environment.apiUrl}/comparison/client-monthly-moving-average/export`,
  weeklyArMovingAverage: `${environment.apiUrl}/comparison/client-weekly-moving-average`,
  exportWeeklyArMovingAverage: `${environment.apiUrl}/comparison/client-weekly-moving-average/export`,
  weeklyCategoryMovingAverage: `${environment.apiUrl}/comparison/service-category-weekly-moving-average`,
  monthlyCategoryMovingAverage: `${environment.apiUrl}/comparison/service-category-monthly-moving-average`,
  monthlyEmployeeEfficiencyRankings: `${environment.apiUrl}/comparison/employee-efficiency-monthly-moving-average`,
  weeklyEmployeeEfficiencyRankings: `${environment.apiUrl}/comparison/employee-efficiency-weekly-moving-average`,
  compareObjectivesByGroup: `${environment.apiUrl}/comparison/objectives-by-group`,
  exportCompareObjectivesByGroup: `${environment.apiUrl}/comparison/objectives-by-group/export`,
  compareObjectivesByRegional: `${environment.apiUrl}/comparison/objectives-by-regional`,
  exportCompareObjectivesByRegional: `${environment.apiUrl}/comparison/objectives-by-regional/export`,
  upsellReport: `${environment.apiUrl}/invoices/upsell-report`,
  upsellList: `${environment.apiUrl}/invoices/filters/upsell`,
  exportUpsellList: `${environment.apiUrl}/invoices/filters/export/upsell`,
  dailyAverageReport: `${environment.apiUrl}/invoices/daily-average`,
  exportDailyAverageReport: `${environment.apiUrl}/invoices/daily-average/export`,
  getAdjustedGP: `${environment.apiUrl}/invoices/adjusted-gross-profit`,
  exportAdjustedGP: `${environment.apiUrl}/invoices/adjusted-gross-profit/export`,
  tiresReport: `${environment.apiUrl}/reports/tires`,
  exportTiresReport: `${environment.apiUrl}/reports/tires/export`
}
